import f from 'odata-filter-builder';
import { transformODataResponse } from 'utilities/query';

import templateUrl from './regulator-autocomplete.html';

export default {
  templateUrl,
  bindings: {
    isRequired: '<',
    onRegulatorSelected: '&'
  },
  controller: class RegulatorAutocomplete {
    constructor(EventEmitter, RegulatorService) {
      'ngInject';

      Object.assign(this, {
        EventEmitter,
        RegulatorService
      });
    }

    searchRegulators(name) {
      return this.RegulatorService.search({
        ...this.RegulatorService.getDefaultQuery(),
        filter: f().and(x => x.contains('AgentName', name))
      }).then(r => transformODataResponse(r).Data);
    }

    selectedRegulatorChanged(selectedRegulator) {
      this.onRegulatorSelected(
        this.EventEmitter({
          regulator: selectedRegulator
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/autocomplete/regulator/regulator-autocomplete.component.js